export default "__VITE_ASSET__B_gHJ_qN__"